// extracted by mini-css-extract-plugin
export default {"wrapper":"resizer_wrapper__0JgsK","horizontal":"resizer_horizontal__Hkxuh","resizer":"resizer_resizer__KIIsK","dot":"resizer_dot__C0fjF","noSelect":"resizer_noSelect__-CQ3D"};